import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash-es';

import {
  NewStockData,
  SectorDetail,
  StockExchangeCodeType,
  SymbolAndStockExchangeCode,
} from '../../lib/models/fundamental/types';
import { GWMarketDataSummaryBucket } from '../../lib/models/gateway/types';
import { RootState } from '../../lib/store';
import { chartSubscription } from '../../lib/store/market-data/subscriptionHelpers';
import { getTopMoversInitialItems } from '../../lib/store/selectors';

import { Grid, LatestNews } from '../../components';
import { useIsMobile } from '../../hooks';
import EpicMovers from '../EpicMovers/EpicMovers';
import HotGappers from '../HotGappers/HotGappers';
import LongTermInvestments from '../LongTermInvestments/LongTermInvestments';
import MarketIndexes from '../MarketIndexes/MarketIndexes';
import PopularGroups from '../PopularGroups/PopularGroups';
import UpcomingEarnings from '../UpcomingEarnings/UpcomingEarnings';
import Week52GainersAndLosers from '../Week52GainersAndLosers/Week52GainersAndLosers';

import styles from './Discover.module.scss';

const Discover = () => {
  const { isMobile } = useIsMobile();
  const newStocks: NewStockData[] = useSelector((state: RootState) => state.fundamental.newStocks);
  const sectorDetails: SectorDetail = useSelector((state: RootState) => state.fundamental.sectorDetails);
  const { topGainers, topLosers } = getTopMoversInitialItems();

  useEffect(() => {
    if (isEmpty(topGainers) && isEmpty(topLosers) && isEmpty(newStocks) && isEmpty(sectorDetails.content)) {
      return () => {
      };
    }

    const mappedSymbols: SymbolAndStockExchangeCode[] = [];

    if (!isEmpty(topGainers)) {
      topGainers.forEach(item => {
        mappedSymbols.push({ symbol: item.symbol, stockExchangeCode: StockExchangeCodeType.US_NASDAQ }); // TODO:HW-1165  Get the stock exchange code from the API response
      });
    }

    if (!isEmpty(topLosers)) {
      topLosers.forEach(item => {
        mappedSymbols.push({ symbol: item.symbol, stockExchangeCode: StockExchangeCodeType.US_NASDAQ }); // TODO:HW-1165  Get the stock exchange code from the API response
      });
    }

    if (!isEmpty(newStocks)) {
      newStocks.forEach(item => {
        mappedSymbols.push({ symbol: item.symbol, stockExchangeCode: StockExchangeCodeType.US_NASDAQ }); // TODO:HW-1165  Get the stock exchange code from the API response
      });
    }

    if (!isEmpty(sectorDetails.content)) {
      sectorDetails.content.forEach(item => {
        mappedSymbols.push({ symbol: item.symbol, stockExchangeCode: StockExchangeCodeType.US_NASDAQ }); // TODO:HW-1165  Get the stock exchange code from the API response
      });
    }

    chartSubscription(mappedSymbols,
      [GWMarketDataSummaryBucket.OneDay]);

    return () => {
      chartSubscription(mappedSymbols,
        [GWMarketDataSummaryBucket.OneDay],
        true);
    };
  }, [topGainers, topLosers, newStocks, sectorDetails.content]);// eslint-disable-line react-hooks/exhaustive-deps

  const extraChildren = (
    <div>
      <UpcomingEarnings />
      <div className={styles.news}>
        <LatestNews />
      </div>
    </div>
  );

  return (
    <Grid
      extraChildren={extraChildren}
      className={isMobile ? styles.noMargin : undefined}
    >
      <MarketIndexes />
      <HotGappers />
      <EpicMovers />
      <Week52GainersAndLosers />
      <PopularGroups />
      <div className={isMobile ? styles.longTermInvestmentsWrapper : undefined}>
        <LongTermInvestments />
      </div>
      {/* TODO: Enable New on the Market feature when the backend team fiexes the konown issues */}
    </Grid>
  );
};

export default Discover;
